import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from "react-router-dom";
import { Input, Col, Row } from 'reactstrap';
import ErrorBoundary from './ErrorBoundary';
import DropdownSelection from '../data/DropDown';
import * as Accounts from '../store/Accounts';
import * as Records from '../store/Records';
import * as Studies from '../store/Studies';
import * as utility from '../data/Utility';


/* Caveat: this.props.studiesState.study must be not null for Edit Study to work correctly here. */

class StudyComplianceScheduleInternal extends React.Component {

    constructor(props) {
        super(props);

		const studyId = utility.propCheck( props.studyId, null );
		const studyName = utility.propCheck( props.studyName, null );
        const disabled = utility.propCheck( props.disabled, true);
        const create = utility.propCheck( props.create, false);
		const error = utility.propCheck( props.error, false );
		let allCompSchedules = utility.propCheck( props.allCompSchedules, { "Event": "", "Holter": "", "12-Lead": "" } );

		const possibleServiceTypes = [Records.recordServiceTypes.event, Records.recordServiceTypes.holter, Records.recordServiceTypes.twelveLead ];

		const possibleSchedulePeriods = [
			"BIWEEKLY",
			"TWICE PER WEEK",
			"WEEKLY",
			"EVERY 2 WEEKS",
			"TWICE PER MONTH",
			"MONTHLY",
			"EVERY 3 MONTHS",
			"EVERY 4 MONTHS",
			"TWICE PER YEAR",
			"ANNUALLY"
		];

		const currentServiceType = Records.recordServiceTypes.event;

		let length12Lead = "";
		let lengthEvent = "";
		let lengthHolter = "";
		let blankingPeriodDays = "";

		if ( ! create ) {
			length12Lead = this.props.studiesState.study.length12Lead;
			lengthEvent = this.props.studiesState.study.lengthEvent;
			lengthHolter = this.props.studiesState.study.lengthHolter;
			blankingPeriodDays = this.props.studiesState.study.blankingPeriodDays;
		}

        this.state = {
			create: create,
			currentServiceType: currentServiceType,
			allCompSchedules: allCompSchedules,
			selectedSchedulePeriod: allCompSchedules[currentServiceType],
			possibleServiceTypes: possibleServiceTypes,
			possibleSchedulePeriods: possibleSchedulePeriods,
			length12Lead: length12Lead,
			lengthEvent: lengthEvent,
			lengthHolter: lengthHolter,
			blankingPeriodDays: blankingPeriodDays,
			onChange: this.props.onChange,
            disabled: disabled,
            error: error,
            studyId: studyId,
            studyName: studyName,
        };

        this.handleValue = this.handleValue.bind(this);
    }

	componentDidMount() {
	}

	componentDidUpdate( prevProps ) {
		if ((prevProps && prevProps.allCompSchedules) !== this.props.allCompSchedules) {
			const selectedSchedulePeriod = this.props.allCompSchedules[this.state.currentServiceType];
			if ( ! this.state.create ) {
				document.getElementById("dropdown_Periods").innerText = selectedSchedulePeriod;
				this.setState({
					selectedSchedulePeriod: selectedSchedulePeriod,
					allCompSchedules: this.props.allCompSchedules,
				});
			}
		}

		if ( this.props.disabled !== this.state.disabled ) {
			this.setState({
				disabled: this.props.disabled,
			});
		}
    }

	handleDropdownServiceTypes( theChoices ) {
		let theChoice = theChoices[0];
		this.setState({ currentServiceType: theChoice });
		const allCompSchedules = this.state.allCompSchedules;
		const selectedSchedulePeriod = allCompSchedules[theChoice];

		document.getElementById("dropdown_Periods").innerText = selectedSchedulePeriod;

		this.setState({
			selectedSchedulePeriod: selectedSchedulePeriod,
		});
	}

	handleDropdownPeriods( theChoices ) {
		let theChoice = theChoices[0];
		let allCompSchedules = { ...this.state.allCompSchedules, [this.state.currentServiceType]: theChoice };
		const selectedSchedulePeriod = allCompSchedules[this.state.currentServiceType];

		document.getElementById("dropdown_Periods").innerText = selectedSchedulePeriod;

		this.setState({
			selectedSchedulePeriod: selectedSchedulePeriod,
			allCompSchedules: allCompSchedules,
		});

		if ( this.state.onChange ) {
			this.state.onChange( "allCompSchedules", allCompSchedules );
		}
	}

    handleValue(value, type) {

        switch (type) {

			case Studies.SchedCompType.blankingPeriodDays:
			case Studies.SchedCompType.length12Lead:
			case Studies.SchedCompType.lengthEvent:
			case Studies.SchedCompType.lengthHolter:
				if ( /(\d*)/.test(value) ) {

					if ( this.state.onChange ) {
						this.state.onChange( type, value * 1 );
					}

					this.setState({ [type]: value * 1 });
				}
				break;

            default:
                break;
        }
    }


    render() {

        var title = "Compliance Schedule";
		const classNameInput = "scheduler";

		const isEvent = this.state.currentServiceType === Records.recordServiceTypes.event;
		const isHolter = this.state.currentServiceType === Records.recordServiceTypes.holter;
		const is12Lead = this.state.currentServiceType === Records.recordServiceTypes.twelveLead;

        return (
            <div className="autoScheduler crfTitle">
                <h1> {title} </h1>

				<Row>

					<Col className="col-lg-2">
						Service Type: &nbsp;
					</Col>
					<Col className="col-lg-2">
						<DropdownSelection
								disabled={false}
								id="dropdown_ServiceType"
								isCheckboxes={false}
								className={classNameInput}
								values={[this.state.currentServiceType]}
								selections={this.state.possibleServiceTypes}
								onSelect={this.handleDropdownServiceTypes.bind(this)} />
					</Col>

				</Row>

				<Row>

					<Col className="col-lg-2">
						Frequency Period &nbsp;
					</Col>
					<Col className="col-lg-2">
						<DropdownSelection
								disabled={this.props.disabled}
								id="dropdown_Periods"
								isCheckboxes={false}
								className={classNameInput}
								values={[this.state.selectedSchedulePeriod]}
								selections={this.state.possibleSchedulePeriods}
								onSelect={this.handleDropdownPeriods.bind(this)} />
					</Col>

				</Row>

				<Row>

					<Col className="col-lg-2">
						Study Length &nbsp;
					</Col>
					<Col className="col-lg-2">
						{is12Lead && <Input className="input" disabled={this.props.disabled} id="studyLengthInput" onChange={(e) => this.handleValue(e.target.value, Studies.SchedCompType.length12Lead)} type="text" value={this.state.length12Lead} /> }
						{isEvent  && <Input className="input" disabled={this.props.disabled} id="studyLengthInput" onChange={(e) => this.handleValue(e.target.value, Studies.SchedCompType.lengthEvent)} type="text" value={this.state.lengthEvent} /> }
						{isHolter && <Input className="input" disabled={this.props.disabled} id="studyLengthInput" onChange={(e) => this.handleValue(e.target.value, Studies.SchedCompType.lengthHolter)} type="text" value={this.state.lengthHolter} /> }
					</Col>

					<Col className="col-lg-2">
						(Months)
					</Col>

				</Row>

				<Row>
					<Col className="col-lg-2">
						&nbsp;
					</Col>
				</Row>

				<Row>

					<Col className="col-lg-2">
						Blanking Period &nbsp;
					</Col>
					<Col className="col-lg-2">
						<Input className="input" disabled={this.props.disabled} id="blankingPeriodInput" onChange={(e) => this.handleValue(e.target.value, Studies.SchedCompType.blankingPeriodDays)} type="text" value={this.state.blankingPeriodDays} />
					</Col>
					<Col className="col-lg-2">
						(Days)
					</Col>

				</Row>

            </div>
        );
    }
}

const StudyComplianceScheduleConnect = withRouter(connect(
    state => ({
        accountsState: state.accounts,
        studiesState: state.studies
    }),
    dispatch => ({
        accountsDispatch: bindActionCreators(Accounts.actionCreators, dispatch),
        studiesDispatch: bindActionCreators(Studies.actionCreators, dispatch)
    })
)(StudyComplianceScheduleInternal));

export default class StudyComplianceSchedule extends React.Component {
    render() {
		var onChange = null;
        var disabled = true;
        var studyId = null;
        var studyName = null;
        var create = false;
		var allCompSchedules = { "Event": "", "Holter": "", "12-Lead": "" };

        const propsState = this.props;
        if (propsState != null) {
            onChange = utility.propCheck(propsState.onChange, null);
            disabled = utility.propCheck(propsState.disabled, disabled);
            studyId = utility.propCheck(propsState.studyId, null);
            studyName = utility.propCheck(propsState.studyName, null);
			allCompSchedules = utility.propCheck( propsState.allCompSchedules, { "Event": "", "Holter": "", "12-Lead": "" } );
            create = utility.propCheck(propsState.create, false);
        }

		if ( typeof allCompSchedules === 'string' || allCompSchedules instanceof String ) {
			allCompSchedules = JSON.parse(allCompSchedules);
		}

        return (
            <ErrorBoundary>
                <StudyComplianceScheduleConnect allCompSchedules={allCompSchedules} onChange={onChange} create={create} disabled={disabled} studyId={studyId} studyName={studyName} />
            </ErrorBoundary>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/EditStudyComplianceSchedule.js